const closeButtonLabel = "Schließen";
const deAT = {
  closeButtonLabel
};
export {
  closeButtonLabel,
  deAT as default
};
